import * as React from 'react';

import IMPComponent from '../interfaces/IMPComponent';

import styled from 'styled-components';

export interface IWordsCountProps extends IMPComponent {
  expectedWordsCount: number;
  actualWordsCount: number;
  children?: React.ReactNode;
}

const WordsCountContainer = styled.div`
  color: ${p => p.theme.color.grey};
`;

const WordsCountLabel = styled.span`
  margin-left: 0.5em;
`;

const WordsCount = ({ expectedWordsCount, actualWordsCount, children }: IWordsCountProps) => {
  return (
    <WordsCountContainer>
      <span>
        {actualWordsCount}/{expectedWordsCount}
      </span>
      {children && <WordsCountLabel>{children}</WordsCountLabel>}
    </WordsCountContainer>
  );
};

export default React.memo(WordsCount);



// WEBPACK FOOTER //
// ./src/components/WordsCount/index.tsx